import ConfigurableComponentsAPI from '@/services/ConfigurableComponents';

function initializeState() {
  return {
    config: {},
    selectedComponentId: null,
    selectedComponent: null,
    component: [],
    showAlert: false,
    alertMessage: '',
    alertState: '',
    snackbarDownload: true,
    snackbarText: 'Download 1',
    downloadList: []
  }
}

const state = initializeState()

const mutations = {
  SET_CONFIG(state, config) {
    state.config = config
  },
  SET_COMPONENT(state, payload)  {
    state.component = [...payload]
  },
  SET_SELECTED_COMPONENT(state) {
    let componentList = Object.keys(state.config)
    console.log('Component list',componentList);
    state.selectedComponentId = componentList.length > 0 ? componentList[0] : ''
    state.selectedComponent = state.config[state.selectedComponentId]
  },
  SET_DOWNLOAD_LIST(state, {id, status}) {
    state.downloadList = state.downloadList.map(item => {
      if (item.id == id) {
        return { ...item, downloading: false, status: status }
      } else {
        return item
      }
    })
  },
  REMOVE_DOWNLOAD_LIST(state) {
    state.downloadList = []
  },
  ADD_DOWNLOAD_LIST(state, downloadName) {
    state.downloadList = [...state.downloadList, downloadName]
  },
  RESET_STATE(state) {
    let initial = initializeState()
    Object.assign(state, initial)
  }
}

const actions = {
  fetchConfig({commit, dispatch}, plantId) {
    ConfigurableComponentsAPI.getConfiguration(plantId).then(res => res.data.data).then(res => {
      commit('SET_CONFIG', res)
      commit('SET_SELECTED_COMPONENT')
      dispatch('fetchComponents', plantId)
    })
  },
  fetchComponents({commit, state}, plantId) {
    // Object.keys(state.settings).forEach()
    ConfigurableComponentsAPI.getDeviceList(plantId).then(res => res.data.data).then(res => {
      commit('SET_COMPONENT', res)
    })
  },
  setComponent({dispatch, commit, state}, payload) {
    ConfigurableComponentsAPI.setDeviceList(payload).then(res => {
      state.showAlert = true
      state.alertState = 'success'
      state.alertMessage = 'Changes were saved successfully'
      setTimeout(() => {
        state.showAlert = false
      }, 3000);
      dispatch('fetchComponents', payload.plantId)
    }).catch(err => {
      state.showAlert = true
      state.alertState = 'error'
      state.alertMessage = 'Failed to save the changes'
      setTimeout(() => {
        state.showAlert = false
      }, 3000);
      console.log("FAILED", err);
    })
  },
  resetState({commit}) {
    commit('RESET_STATE')
  }
}

const getters = {
  getDownloadList(state) {
    return state.downloadList;
  },

  getSnackbarText(state) {
    return state.snackbarText
  },

  getSnackbarDownload(state) {
    return state.snackbarDownload
  },
  getComponentList(state) {
    return Object.keys(state.config).map(key => ({
      id: key,
      name: state.config[key].title
    }))
  },
  getSelectedComponentName(state) {
    return state.config[state.selectedComponentId] ? state.config[state.selectedComponentId].title : ''
  },
  getConfigurableComponentList(state) {
    return state.component
  },
  getSelectedComponentSetting(state) {
    return state.selectedComponent ? state.selectedComponent.settings : []
  },
  showAlert(state) {
    return state.showAlert
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}